import React, { useContext, useEffect, useRef, useState } from "react";
import { Form } from "react-router-dom";
import Function from "../../../StateContext/Application";
import {
  Email32,
  PhoneNumber32,
  submit,
   Cancel32,
   Edit32WHITE
} from "../../../../../public/LoginImages/importimages";

// ---- inline icons (match the reference UI) ----
const PersonIcon = ({ color = "#9aa0a6" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="12" cy="8" r="4" stroke={color} strokeWidth="2" />
    <path
      d="M4 20c0-3.3137 3.5817-6 8-6s8 2.6863 8 6"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

const VerifiedBadgeIcon = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2l2.2 1.6 2.7-.3 1 2.5 2.5 1-.3 2.7L22 12l-1.9 2.5.3 2.7-2.5 1-1 2.5-2.7-.3L12 22l-2.2-1.6-2.7.3-1-2.5-2.5-1 .3-2.7L2 12l1.9-2.5-.3-2.7 2.5-1 1-2.5 2.7.3L12 2z"
      stroke="#1266c4"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12.3l2.2 2.2 4.3-4.6"
      stroke="#1266c4"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const PhoneIconSvg = ({ color = "#2fb344" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M6.6 10.8c1.4 2.8 3.8 5.2 6.6 6.6l2.2-2.2c.3-.3.7-.4 1.1-.3 1.2.4 2.5.6 3.8.6.6 0 1 .4 1 1V20c0 .6-.4 1-1 1C10.6 21 3 13.4 3 4c0-.6.4-1 1-1h3.5c.6 0 1 .4 1 1 0 1.3.2 2.6.6 3.8.1.4 0 .8-.3 1.1L6.6 10.8z"
      stroke={color}
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
  </svg>
);

const EmailIconSvg = ({ color = "#e05a3b" }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="3" y="5" width="18" height="14" rx="2" stroke={color} strokeWidth="1.8" />
    <path d="M3.5 6.5L12 13l8.5-6.5" stroke={color} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

const EyeIconSvg = ({ open }) => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2 12C2 12 5.5 5 12 5C18.5 5 22 12 22 12C22 12 18.5 19 12 19C5.5 19 2 12 2 12Z"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx="12" cy="12" r="3" stroke="#fff" strokeWidth="2" />
    <line
      x1="4"
      y1="4"
      x2="20"
      y2="20"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      style={{ opacity: open ? 0 : 1 }}
    />
  </svg>
);

const ProfileManagement = () => {
  const types = useContext(Function);
  const { EmployeeManagement } = types;

  const [EmployeeList, SetEmployeeList] = useState([]);
  const [formData, setFormData] = useState({
    ID: "",
    FullName: "",
    ProfilePic: "",
    PhoneNumber: "",
    Email: "",
    Password: "",
    RoleID: "",
    Role: "",
    Department_ID: "",
    Department_Name: "",
    Username: "",
  });

  const formdataref = useRef(null);
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(true);

  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    try {
      let employees = await EmployeeManagement("View", null);
      SetEmployeeList(employees || []);


      let profile = await EmployeeManagement("ViewProfile", null);

      if (profile) {
        setFormData({
          ID: profile.ID || "",
          FullName: profile.FullName || "",
          ProfilePic: profile.ProfilePic || "",
          PhoneNumber: profile.PhoneNumber || "",
          Email: profile.Email || "",
          Password: profile.Password || "", // 26-10  prefilled — leave blank to keep the current password
          RoleID: profile.RoleID || "",
          Role: profile.Role || "",
          Department_ID: profile.Department_ID || "",
          Department_Name: profile.Department_Name || "",
          Username: profile.Username || "",
        });
      }
    } catch (error) {
      console.error("Get Data Error =>", error);
    } finally {
      setLoading(false);
    }
  };

  const isEmailTaken = (email) =>
    EmployeeList.some(
      (emp) => emp.Email?.trim().toLowerCase() === email.trim().toLowerCase(),
    );

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const Submit = async (e) => {
    e.preventDefault();
    try {
      if (isEmailTaken(formData.Email)) {
        alert(
          "This email is already registered. Please use a different email.",
        );
        return;
      }

      let data = await EmployeeManagement("UpdateProfile", formData);

      if (data === true) {
        // Keep the app's cached user object in sync so name/pic/etc.
        // reflect immediately anywhere else it's read from.
        let storedUser =
          JSON.parse(localStorage.getItem("User")) ||
          JSON.parse(localStorage.getItem("user"));

        if (storedUser) {
          let updatedUser = {
            ...storedUser,
            FullName: formData.FullName,
            PhoneNumber: formData.PhoneNumber,
            Email: formData.Email,
            Username: formData.Username,
            ProfilePic: formData.ProfilePic,
          };
          if (localStorage.getItem("User")) {
            localStorage.setItem("User", JSON.stringify(updatedUser));
          } else {
            localStorage.setItem("user", JSON.stringify(updatedUser));
          }
        }

        alert("Profile Updated Successfully");

        setShowPassword(false);
        await getData();
        setIsEditing(false);
      } else {
        alert("Profile Not Updated");
      }
    } catch (error) {
      console.error(error);
    }
  };

  
  const resetData = async () => {
    setLoading(true);
    await getData();
    setShowPassword(false);
    setIsEditing(false);
  };

  if (loading) {
    return (
      <div style={{ padding: "20px" }}>
        <p>Loading profile...</p>
      </div>
    );
  }
  const rowStyle = {
    display: "grid",
    gridTemplateColumns: "180px 1fr",
    alignItems: "center",
    marginBottom: "20px",
  };

  //2/11
  const labelStyle = {
    fontSize: "14px",
    fontWeight: "700",
    color: "#2b2b2b",
  };

  const requiredStyle = {
    color: "#e53935",
    marginLeft: "2px",
  };

  const inputStyle = () => ({
    width: "100%",
    height: "44px",
    padding: "8px 42px 8px 14px",
    fontSize: "14px",
    color: "rgb(85 88 91);",
    backgroundColor: "#ffffff",
    border: "1px solid #dfe3ee",
    borderRadius: "8px",
    outline: "none",
    boxShadow: "none",
  });

  const iconWrapStyle = {
    position: "absolute",
    right: "10px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  };

  return (
    <div
      style={{
        padding: "24px",
        backgroundColor: "#ffffff",
        minHeight: "90vh",
        maxHeight: "90vh",
        overflowY: "auto",
      }}
    >

       {/* Header row: badge icon + title + Edit button */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "10px", }}>
           <i
          className="fa fa-user"
          style={{
             marginLeft:"30px",
            color: "#044c92",
            fontSize: "18px",
          }}
        ></i>
            <h4 style={{ fontSize: "20px", fontWeight: "700", margin: 0, color: "#1a1a1a", marginLeft:"15px" }}>
              Edit / View Profile
            </h4>
          </div>

          {!isEditing && (
            <button
              type="button"
              onClick={() => setIsEditing(true)}
              style={{
                display: "flex",
                alignItems: "center",
                gap: "6px",
                backgroundColor: "#1266c4",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                padding: "9px 22px",
                fontSize: "14px",
                fontWeight: "600",
                cursor: "pointer",
                //2/11
                marginRight:"40px"
              }} >
              {/* //2/11 */}
                   <img src={Edit32WHITE} alt="Edit" style={{ width: "18px", height: "20px" }} />
               Edit
            </button>
          )}
        </div>
        {/* //2/11 */}
<div style={{ backgroundColor: "#ffffff", borderRadius: "12px", boxShadow: "0 2px 12px rgba(0,0,0,0.08)", padding: "20px", maxWidth: "960px", margin: "0 auto" }}>
     {/* //2/11 */}
      <div
        style={{
          maxWidth: "1100px",
          margin: "0 auto",
          backgroundColor: "#EEF1F6",
          borderRadius: "16px",
          boxShadow: "0 4px 18px rgba(0,0,0,0.05)",
          padding: "28px 34px",
          
        }}
      >
       
        <Form onSubmit={Submit} ref={formdataref}>
          <div style={rowStyle}>
            <label style={labelStyle}>
              Employee Name<span style={requiredStyle}>*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                name="FullName"
                value={formData.FullName}
                disabled={!isEditing}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^[A-Za-z\s]*$/.test(value)) {
                    handleChange(e);
                  }
                }}
                required
                placeholder="Enter Full Name Here"
                style={inputStyle(isEditing)}
              />
              <div style={iconWrapStyle}>
                <PersonIcon />
              </div>
            </div>
          </div>

          <div style={rowStyle}>
            <label style={labelStyle}>
              Username<span style={requiredStyle}>*</span>
            </label>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                name="Username"
                value={formData.Username}
                disabled={!isEditing}
                onChange={handleChange}
                required
                placeholder="Enter Username Here"
                style={inputStyle(isEditing)}
              />
              <div style={iconWrapStyle}>
                <PersonIcon />
              </div>
            </div>
          </div>

          <div style={rowStyle}>
            <label style={labelStyle}>Phone Number</label>
            <div style={{ position: "relative" }}>
              <input
                type="tel"
                name="PhoneNumber"
                value={formData.PhoneNumber}
                disabled={!isEditing}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "").slice(0, 12);
                  handleChange({ target: { name: "PhoneNumber", value } });
                }}
                placeholder="Enter Phone Number Here"
                maxLength={10}
                inputMode="numeric"
                style={inputStyle(isEditing)}
              />
              <div style={iconWrapStyle}>
                <PhoneIconSvg />
              </div>
            </div>
          </div>

          <div style={rowStyle}>
            <label style={labelStyle}>Email</label>
            <div style={{ position: "relative" }}>
              <input
                type="email"
                name="Email"
                value={formData.Email}
                disabled={!isEditing}
                onChange={handleChange}
                onBlur={(e) => {
                  if (isEditing && isEmailTaken(e.target.value)) {
                    alert("This email is already in use.");
                  }
                }}
                placeholder="Enter Email Here"
                style={inputStyle(isEditing)}
              />
              <div style={iconWrapStyle}>
                <EmailIconSvg />
              </div>
            </div>
          </div>

          {/* Role / Department are always read-only — only an admin can
              change these, via the Employee Management page. */}
          <div style={rowStyle}>
            <label style={labelStyle}>Role</label>
            <input
              type="text"
              value={formData.Role}
              disabled
              style={inputStyle(false)}
            />
          </div>

          <div style={rowStyle}>
            <label style={labelStyle}>Department</label>
            <input
              type="text"
              value={formData.Department_Name}
              disabled
              style={inputStyle(false)}
            />
          </div>

        


{isEditing && (
  <div style={rowStyle}>
    <label style={labelStyle}>Password</label>

    <div style={{ position: "relative" }}>
      <input
        type={showPassword ? "text" : "password"}
        name="Password"
        value={formData.Password}
        onChange={handleChange}
        placeholder="New Password"
        style={{ ...inputStyle(true), paddingRight: "50px" }}
      />

      <div
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "6px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "32px",
          height: "32px",
          borderRadius: "6px",
          backgroundColor: "#1266c4",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          cursor: "pointer",
        }}
      >
        <EyeIconSvg open={showPassword} />
      </div>
    </div>
  </div>
)}



          {/* Submit / Cancel only appear once editing has started */}
          {isEditing && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                gap: "14px",
                marginTop: "10px",
              }}
            >
              <button
                type="submit"
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: "10px",
                  width: "6rem",
                  height: "2.6rem",
                  backgroundColor: "#028bc9",
                  color: "#fff",
                  border: "none",
                  fontSize: "13px",
                  fontWeight: "600",
                  gap: "6px",
                  cursor: "pointer",
                }}
              >
                <img src={submit} style={{ width: "1.2rem" }} /> Update
              </button>

              <button
                onClick={resetData}
                type="button"
                style={{
                  borderRadius: "10px",
                  width: "6rem",
                  height: "2.6rem",
                  backgroundColor: "#f02b2b",
                  color: "#fff",
                  border: "none",
                  fontSize: "13px",
                  fontWeight: "600",
                  cursor: "pointer",
                }}
              > <img
              src={Cancel32}
              style={{ marginRight: "10px", width: "1.2rem" }}
            />{" "}
                Cancel
              </button>
            </div>
          )}
        </Form>
        </div>
      </div>
    </div>
  );
};

// small check-badge used inside the Edit button
const VerifiedBadgeIconSmall = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12 2l2.2 1.6 2.7-.3 1 2.5 2.5 1-.3 2.7L22 12l-1.9 2.5.3 2.7-2.5 1-1 2.5-2.7-.3L12 22l-2.2-1.6-2.7.3-1-2.5-2.5-1 .3-2.7L2 12l1.9-2.5-.3-2.7 2.5-1 1-2.5 2.7.3L12 2z"
      stroke="#fff"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 12.3l2.2 2.2 4.3-4.6"
      stroke="#fff"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ProfileManagement;
